<template>
  <div class="comp-fh-board-item" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <!-- 计算异常 -->
    <template v-if="_rowItem?.computedInfo?.status == 2">
      <ly-computed-icon-tips :computedInfo="_rowItem?.computedInfo" />
    </template>
    <template v-if="computingStatus.includes(_rowItem?.computedInfo?.status)">
      <jw-tooltip :content="_rowItem?.computedInfo?.status === 1 ? '公式计算中，计算成功后触发后续操作' : '数据处理中'">
        <icon-refresh :size="16" style="color: rgb(var(--primary-6))" spin @click="getComputedStatus([_rowItem.id])" class="computed-status-icon" />
      </jw-tooltip>
    </template>
    <!-- AI总结汇总 -->
    <jw-tooltip v-if="aiSummaryOptions.enabled" :content="$t('AI总结汇总')">
      <div class="index-ai-icon" :data-id="_rowItem.id" @click.stop="aiSummaryOptions.setActiveData(_rowItem)">
        <img :src="aiIcon" :alt="$t('AI总结汇总')" />
      </div>
    </jw-tooltip>
    <!-- 操作按钮 -->
    <div @click.stop class="gr-mainfield-icon" :style="{ opacity: isMoveBtn || isClickBtn ? 1 : 0 }">
      <shortcut-btn :key="JSON.stringify(shortcutBtnPermission)" v-if="isFirstBtn && _rowItem.LOGIC_ROLE_PERMISSION && _rowItem.LOGIC_ROLE_PERMISSION == 1" :viewId="viewId" :entityId="entityId" :fieldsListAll="shortcutBtnPermission" :recordObj="_rowItem" :moreNumber="0" morePosition="br" :computedStatus="_rowItem.computedInfo?.status" @cb="shortcutBtnCb" @popupVisibleChangeBtn="handlePopupVisibleChangeBtn">
        <template #board-view>
          <icon-more @click="handleMoreClick" />
        </template>
      </shortcut-btn>
    </div>
    <!-- 主属性 -->
    <div class="gr-mainfield">{{ _rowItem[mainField] }}</div>
    <template v-for="(c, i) in allColumns" :key="i">
      <template v-if="c?.fieldType != 27">
        <!-- 字段 -->
        <template v-if="!c?.mainField">
          <div v-if="businessData !== '1'" class="gr-field">
            <component :is="componentFun(c)" />
            {{ c.fieldName }}
          </div>
          <div class="gr-value" :class="{ 'ellipsis-content-decoration': [12, 25]?.includes(c.fieldType), 'ellipsis-content-link': c.fieldType == 11 }">
            <template v-if="textArray?.includes(c.fieldType)">
              <textarea-cmp :fieldValue="_rowItem[c.fieldKey]" :fieldInfo="c" />
            </template>
            <template v-else>
              <template v-if="shouldShowContent(_rowItem[c.fieldKey], c)">
                <component :is="getComponent(c)" :entityId="entityId" :params="getParamsFieldValue(_rowItem[c.fieldKey], c)" />
              </template>
              <div v-else class="field-content-empty">
                <template v-if="c?.fieldKey == 'qccId'">
                  <jw-tag size="small" :color="_rowItem[c.fieldKey] ? 'green' : 'pink'">{{ _rowItem[c.fieldKey] ? $t('是') : $t('否') }}</jw-tag>
                </template>
                <template v-else>{{ emptyText }}</template>
              </div>
            </template>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script setup>
import { emptyText } from '@/utils/const';
import { computed, inject, ref } from 'vue';
import TextareaCmp from '../textarea/textarea.vue';
import ShortcutBtn from '@/components/fh-list/fh-shortcut-batch/components/shortcut-btn/shortcut-btn.vue';

import useObjectForm from '@/hooks/object-form';
const { componentFun } = useObjectForm();
import { computingStatus } from '@/utils/const';
import { tools } from '@/utils/tools';
import useShowFields from '@/hooks/field-show';
import aiIcon from '@/assets/images/ai/ai-icon.svg';
const { getfieldShowCom } = useShowFields();
const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  },
  viewId: {
    type: String,
    default: ''
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  entityId: {
    type: String,
    default: ''
  },
  // 是否隐藏看板label 1.隐藏 0.展示
  businessData: {
    type: String,
    default: '0'
  },
  shortcutBtnPermission: {
    type: Object,
    default: () => ({})
  }
});
const emit = defineEmits(['getComputedStatus', 'shortcutBtnCb']);
// 加载状态   首次加载时，鼠标移入才显示操作按钮
const isFirstBtn = ref(false);
// 移入状态   用来控制 icon 是否显示
const isMoveBtn = ref(false);
// 点击状态   用来控制 icon 是否显示
const isClickBtn = ref(false);

// AI汇总
const aiSummaryOptions = inject('aiSummaryOptions', {});

const _rowItem = computed(() => props.rowItem);
// 所有列
const allColumns = computed(() => props.columns);
// 主属性列
const mainField = computed(() => props.columns?.filter((v) => v?.mainField)?.[0]?.fieldKey);
const textArray = [0, 1, 26];
const getComponent = (c) => {
  return getfieldShowCom[c.fieldType] || getfieldShowCom[1];
};

const getParamsFieldValue = (cvf, c) => ({
  ...c,
  fieldValue: cvf,
  sourceType: c?.fieldType == 18 ? 1 : 2,
  mask: false
});

// 获取计算状态
const getComputedStatus = (ids) => {
  emit('getComputedStatus', ids);
};

const shortcutBtnCb = (params, type) => {
  emit('shortcutBtnCb', params, type);
};

// 判断是否显示内容---为null和undefined、空数组、空对象、空字符串不显示，但等于0或fieldType==24时显示
const shouldShowContent = (_value, c) => {
  if (c?.fieldType === 24) return true;
  // null和undefined排除
  if (_value == null) return false;
  if (_value === 0) return true;
  if (typeof _value === 'string') return _value?.length;
  if (Array.isArray(_value)) return _value?.length;
  if (typeof _value === 'object') return Object.keys(_value)?.length;
  return true;
};

const handlePopupVisibleChangeBtn = (e) => {
  if (!e) {
    isClickBtn.value = false;
    return;
  }
};
const handleMoreClick = () => {
  isClickBtn.value = true;
};

const handleMouseEnter = () => {
  isFirstBtn.value = true;
  isMoveBtn.value = true;
};
const handleMouseLeave = () => {
  isMoveBtn.value = false;
};
tools.debounceFn(handleMouseEnter, 200, false);
tools.debounceFn(handleMouseLeave, 200, false);
</script>
<style scoped lang="less">
@import './fh-board-item.less';
</style>
